export const USER_ROLES = {
  admin: "admin",
  user: "user",
  contentCreator: "content creator",
  franchise:"franchise",
  vendor:"vendor"
};
